import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import { IconButton, type ITooltipProps, TextareaWithLabel } from 'shared/ui'
import { useTextareaAutoResize } from 'shared/hooks'

export type IPromptField = {
  value: string
  onChange: (value: string) => void
  error?: string
  resetField: () => void
  label: string
  placeholder?: string
  questionTooltipProps?: ITooltipProps
  classNameTextarea?: string
  limit?: number
  maxHeight?: number
  minHeight?: number
  className?: string
  rightTopAction?: ReactNode
}

export const PromptField = observer(
  ({
    value,
    error,
    onChange,
    resetField,
    label,
    placeholder,
    questionTooltipProps,
    classNameTextarea,
    limit,
    maxHeight,
    minHeight,
    className,
    rightTopAction,
  }: IPromptField) => {
    const textareaRef = useTextareaAutoResize(value, minHeight, maxHeight)

    return (
      <TextareaWithLabel
        ref={textareaRef}
        value={value}
        errorType='bottomText'
        name={'field'}
        onChange={onChange}
        className={className}
        classNameTextarea={classNameTextarea}
        error={error}
        placeholder={placeholder}
        limit={limit}
        labelProps={{
          marginBottom: 0,
          questionTooltipProps,
          label: {
            text: label,
            rightNode: (
              <>
                {rightTopAction}
                <IconButton
                  iconProps={{ fontSize: 16 }}
                  variant={'icon'}
                  color={'tertiary'}
                  size={'small'}
                  icon={'back'}
                  ariaLabel='Reset'
                  onClick={resetField}
                  tooltipProps={{
                    label: 'Reset to default',
                    placement: 'top',
                  }}
                />
              </>
            ),
          },
        }}
      />
    )
  }
)
